<fgb-page-header [pageTitle]="'polls.banner.text'" [backButtonLink]="'/games'" [showFooter]="false"></fgb-page-header>

<div class="game-details-banner bg-primary w-100">
  <div class="container">
    <a class="text-white fw-bold d-flex flex-row align-items-center" [routerLink]="'/games'"
      ><span class="pe-2 material-icons fw-bold">keyboard_arrow_left</span>{{ 'games.back.btn' | translate }}</a
    >

    <img [src]="'banners/games/polls-banner.png' | contentAssetImage" alt="Game details banner" />
  </div>
</div>

<div class="bg-muted">
  <div class="container my-lg-4 mb-4">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <ng-container *ngIf="pollsQuestions.length > 0; else noGames">
        <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
        </fgbcl-game-polls-question-list>
      </ng-container>

      <ng-template #noGames>
        <div class="games-placeholder">
          <div class="no-items m-0 no-results-placeholder-div p-4 pt-5 mt-4">
            <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/games/Polls.svg'"></div>
            <div class="no-results-placeholder text-center">{{ 'fgbcl.game.no.item.available.polls.text' | translate }}</div>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- Shimmer Effect -->
    <ng-template #shimmerEffect>
      <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
        <h6 class="card-title placeholder-glow text-center">
          <span class="question-shimmer-effect placeholder col-6"></span>
        </h6>
        <div class="answer-shimmer-effect-section">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="answer-shimmer-effect-section mt-3">
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
          <p class="card-text placeholder-glow w-100 mb-0 text-center">
            <span class="answer-shimmer-effect placeholder col-12"></span>
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <p class="card-text placeholder-glow w-40 text-center">
            <span class="presentby-shimmer-effect placeholder col-7"></span>
          </p>
        </div>
      </div>
    </ng-template>
  </div>
</div>
